import { popServices } from '../../services'

function getProcessors() {
  return () => popServices.getProcessors()
}

export default {
  getProcessors,
}
